import { HashLink } from "react-router-hash-link";
import "./intro.scss";

function Intro() {
    return (
        <div className="intro" id="Home">
            <div className="intro-text">
                <div className="intro-title">
                    <div className="title-suptitle">
                        My name is
                    </div>
                    <div className="title">
                        Roman Tyrtychko
                    </div>
                    <div className="title-subtitle">
                        I am Frontend Developer
                    </div>
                </div>
                <div className="intro-subtitle">
                    I create modern websites for clients around the world.
                    Websites which provide beautiful design and complete user experience is my passion.
                </div>
                <div className="intro-btn">
                    <HashLink to={'#Contacts'} className="contact-btn">
                        Contact me
                    </HashLink>
                </div>
            </div>
            <div className="intro-image">
                <img src="assets/intro.png" alt="" />
            </div>
        </div>
    )
}

export default Intro